import React from "react";
import { MultiSearchSelector, Option, Text, useTranslation } from "@familyzone/component-library";
import { FilteringSourceCriteria } from "../criteriaTypes";
import { TimePeriod } from "../../../pages/filtering/types";

export interface PeriodCriteriaProps {
  criteria: FilteringSourceCriteria;
  disabled: boolean;
  onChange: (criteria: FilteringSourceCriteria) => void;
  timePeriods: TimePeriod[];
}

const PeriodCriteria: React.FC<PeriodCriteriaProps> = ({ criteria, disabled, onChange, timePeriods }) => {
  const { t } = useTranslation();

  if (!Array.isArray(criteria.conditions)) {
    return <Text>{t("Invalid Criteria")}</Text>;
  }

  // Map the list of users to a selector-usable array of label/value pairs
  const periodOptions: Option[] = timePeriods.map((i) => ({ label: i.name, value: i.id }));

  // Take the criteria conditions and convert them to label/value pairs
  const selectedPeriodOptions: Option[] = criteria.conditions
    .map((id) => periodOptions.find((o) => o.value === id))
    .filter((b): b is Option => !!b);

  const handleChangePeriodObjects = (options: Option[]) => {
    onChange({ ...criteria, conditions: [...options.map((o: Option) => timePeriods.find((u) => u.id === o.value)?.id || "")] });
  };

  return (
    <MultiSearchSelector
      disabled={disabled}
      placeholder={t("Select Time Periods")}
      name="time period selector"
      options={periodOptions}
      selected={selectedPeriodOptions}
      onChange={handleChangePeriodObjects}
    />
  );
};

export default PeriodCriteria;
